import React from 'react'
import { Modal, Row } from 'antd'
import VehicleForm from '../../../../components/Project/Resources/Vehicles/VehicleForm'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function VehicleModal(props) {
  const { visible, modalType, submitting, submit, update, formRef, onCancel, removing, remove } = props
  return (
    <Modal
      visible={visible}
      title={'Vehicle'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          remove={remove}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Department'}
          isNew={modalType === 'new'}
          isEdit={modalType !== 'new'}
        />
      }
      width={'75%'}>
      <Row>
        <VehicleForm ref={formRef} {...props} />
      </Row>
    </Modal>
  )
}

VehicleModal.propTypes = {}
VehicleModal.defaultProps = {}

export default VehicleModal
